import app from '../app.first';

app.PnetValidation = class extends app.Component {
    onReady() {
        this.$el.find('form').on('submit', function (e) {
			e.preventDefault();

			var isValid = true;

			$('textarea').each(function () {
				if ($(this).attr('data-required')) { 
					var redactorContent = $(this).val().trim();

					if (redactorContent === '') {
						isValid = false;
						// Add a red border class
						$(this).addClass('is-invalid');
		
						// Check if the error message already exists, if not, add it
						if (!$(this).next('.error-message').length) {
							$('<div class="error-message" style="color: red; margin-top: 5px;">This field is required.</div>').insertAfter($(this).parent());

							//add style 2px red border
							$(this).parent().css('border', '2px solid #CB2D29');
						}
					}
				}
			});
			
			//if isvalid subnit form
			if (isValid) {
				this.submit();
			}	
		});
    }
}